import {
  LOAD_LAB_RESULTS,
  LOAD_MAP_REPORTS,
  DOWNLOAD_ZIP,
} from './constants'

export function loadLabResults (payload) {
  return {
    type: LOAD_LAB_RESULTS,
    payload,
  }
}

export function loadMapReports (payload) {
  return {
    type: LOAD_MAP_REPORTS,
    payload,
  }
}

export function downloadZip (payload) {
  return {
    type: DOWNLOAD_ZIP,
    payload,
  }
}
